// Explicit build input: malformed or absent values must not silently disable verification.
export function readTrialChangeLimit(value) {
    const text = typeof value === 'number' ? String(value) : value;
    if (typeof text !== 'string' || !/^(0|[1-9][0-9]*)$/.test(text)) {
        throw new Error('Trial verification threshold is missing or invalid.');
    }
    const limit = Number(text);
    if (!Number.isSafeInteger(limit) || limit > 2147483647) {
        throw new Error('Trial verification threshold is invalid.');
    }
    return limit;
}

export function trialChangeLimitReached(changes, limit) {
    return changes >= readTrialChangeLimit(limit);
}
